import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ActivityTypeCode } from "project-config/constants/activity-code";
import { useLocation, useSearchParams } from "react-router-dom";
import { usePictureTopUpStore } from "../store";
import { useFetchActivityInfoList } from "./useFetchActivityInfoList";
import {
  defaultPictureBalanceTab,
  defaultPictureVipTab,
} from "../constants/picture-balance-info";
import { CommonContainer } from "../atom";
import { PictureBalanceRecharge } from "../components/picture-balance-recharge";
import { BindActivityInfo } from "@/components/top-up/types";
import { PictureVipRecharge } from "../components/picture-vip-recharge";
import DefaultAdvise from "@/assets/images/default-advise.png";
import { useGlobalStore } from "@/store/GlobalStore";
import { DesktopRecharge } from "../components/desktop-recharge";
import { DesktopRechargeTab } from "../constants/picture-balance-info";

export function useInitTabList() {
  const { t } = useTranslation("topup");
  const { userInfo } = useGlobalStore();
  useFetchActivityInfoList();
  const { setter } = usePictureTopUpStore();
  const activityInfoList = usePictureTopUpStore(
    (state) => state.activityInfoList
  );
  const activeName = usePictureTopUpStore((state) => state.activeName);
  const haveGiftMemberActivity = usePictureTopUpStore(
    (state) => state.haveGiftMemberActivity
  );
  const haveRechargeGiftActivity = usePictureTopUpStore(
    (state) => state.haveRechargeGiftActivity
  );
  const giftMemberActivity = usePictureTopUpStore(
    (state) => state.giftMemberActivity
  );
  const rechargeGiftActivity = usePictureTopUpStore(
    (state) => state.rechargeGiftActivity
  );
  const desktopActivity = usePictureTopUpStore(
    (state) => state.desktopActivity
  );
  // const { isZh } = useGlobalStore();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const getActivityTab = useCallback(
    (activityInfo: BindActivityInfo) => {
      const { activityType, imageUrlLink, imageUrlLinkEventDetails } =
        activityInfo;
      return {
        label:
          activityType === ActivityTypeCode.RechargeGift
            ? t("topUp_recharge_tab")
            : t("topUp_tab_picture"),
        key: activityInfo.id.toString(),
        advertiseImg: imageUrlLink || DefaultAdvise,
        advertiseLink: imageUrlLinkEventDetails || "",
        children: (
          <CommonContainer>
            {activityType === ActivityTypeCode.RechargeGift && (
              <PictureBalanceRecharge activityInfo={activityInfo} />
            )}
            {activityType === ActivityTypeCode.GiftMember && (
              <PictureVipRecharge activityInfo={activityInfo} />
            )}
          </CommonContainer>
        ),
      };
    },
    [t]
  );

  const desktopTabItem = useCallback(
    (activityInfo: BindActivityInfo) => {
      const { imageUrlLink, imageUrlLinkEventDetails } = activityInfo;
      return {
        label: t("desktop_recharge"),
        key: DesktopRechargeTab.Desktop,
        advertiseImg: imageUrlLink || DefaultAdvise,
        advertiseLink: imageUrlLinkEventDetails || "",
        children: (
          <CommonContainer>
            <DesktopRecharge activityInfo={activityInfo} />
          </CommonContainer>
        ),
      };
    },
    [t]
  );

  const getTabsList = useCallback(() => {
    const tabList = [];
    if (!activityInfoList.length) {
      tabList.push(defaultPictureBalanceTab, defaultPictureVipTab);
    } else {
      tabList.push(
        haveRechargeGiftActivity()
          ? getActivityTab(rechargeGiftActivity())
          : defaultPictureBalanceTab,
        haveGiftMemberActivity()
          ? getActivityTab(giftMemberActivity())
          : defaultPictureVipTab
      );
    }
    if (userInfo?.enableRemoteDesktop) {
      tabList.push(desktopTabItem(desktopActivity()));
    }
    return tabList;
  }, [
    activityInfoList,
    haveRechargeGiftActivity,
    haveGiftMemberActivity,
    getActivityTab,
    rechargeGiftActivity,
    giftMemberActivity,
    desktopTabItem,
    desktopActivity,
    userInfo?.enableRemoteDesktop,
  ]);

  useEffect(() => {
    // 效果图活动 -- 充值送xx活动 =》 不显示现金充值卡片
    // 效果图活动 -- 购买会员送xx活动 =》 不显示订阅d会员卡片(202312需求，两者活动可以并存显示)
    // 存在效果图活动
    const activeNameParam = searchParams.get("activeName");
    const isPictureRecharge =
      haveGiftMemberActivity() || haveRechargeGiftActivity();
    const searchActiveName = location.search.split("=")[1];
    const isChargeVIP = searchActiveName === "picture-vip-item";
    if (isPictureRecharge) {
      // if (!activeName && isChargeVIP) {
      //   // 当充值送xx活动和购买会员并存时，优先选中充值送xx活动tab，其次购买会员活动tab
      //   setter((state) => {
      //     state.activeName = haveRechargeGiftActivity()
      //       ? rechargeGiftActivity().id.toString()
      //       : haveGiftMemberActivity()
      //       ? giftMemberActivity().id.toString()
      //       : searchActiveName;
      //   });
      //   return;
      // }
      // if (
      //   (!activeName ||
      //     !getTabsList().find((item) => item.key === activeName)) &&
      //   !isChargeVIP
      // ) {
      //   setter((state) => {
      //     state.activeName = getTabsList()[0].key;
      //   });
      //   return;
      // }
      // setter((state) => {
      //   state.activeName =
      //     activeNameParam &&
      //     getTabsList().find((item) => item.key === activeNameParam)
      //       ? activeNameParam
      //       : getTabsList()[0]?.key;
      // });
      const vipPictureTab = haveGiftMemberActivity()
        ? giftMemberActivity().id.toString()
        : searchActiveName;
      setter((state) => {
        state.activeName =
          activeNameParam &&
          getTabsList().find((item) => item.key === activeNameParam)
            ? activeNameParam
            : isChargeVIP
            ? vipPictureTab
            : getTabsList()[0].key;
      });
    } else {
      // if (!getTabsList().find((item) => item.key === activeName)) {
      //   setter((state) => {
      //     state.activeName = getTabsList()[0].key;
      //   });
      // }
      if (
        activeNameParam &&
        (getTabsList().find((item) => item.key === activeNameParam) ||
          (DesktopRechargeTab.Desktop === activeNameParam &&
            userInfo?.enableRemoteDesktop))
      ) {
        setter((state) => {
          state.activeName = activeNameParam;
        });
      } else {
        setter((state) => {
          state.activeName = getTabsList()[0].key;
        });
      }
    }
  }, [
    activityInfoList,
    location,
    searchParams,
    activeName,
    getTabsList,
    haveGiftMemberActivity,
    haveRechargeGiftActivity,
    rechargeGiftActivity,
    giftMemberActivity,
    setter,
    userInfo?.enableRemoteDesktop,
  ]);

  return {
    getTabsList,
  };
}
